module.exports = __webpack_public_path__ + "img/498127-2.22daf92f.png";